import React from 'react';
import NavBtn from '../Common/NavBtn';
import './SideNav.css'

import Dash from '../../Assets/Icons/Dash.svg'
import Events from '../../Assets/Icons/Events2.svg'
import Bookings from '../../Assets/Icons/Bookings2.svg'
import Users from '../../Assets/Icons/Users2.svg'
import Payments from '../../Assets/Icons/Payments.svg'
import Blog from '../../Assets/Icons/Blog.svg'

const SideNav = () => {
    return ( 
        <div className='SideNav'>
            <NavBtn LinkPath='/' NavBtnStyle='NavBtn' NavIcon={Dash} NavText="Dashboard"/>
            <NavBtn LinkPath='/Events' NavBtnStyle='NavBtn' NavIcon={Events} NavText="Events"/>
            <NavBtn LinkPath='/Booking' NavBtnStyle='NavBtn' NavIcon={Bookings} NavText="Bookings"/>
            <NavBtn LinkPath='/Users' NavBtnStyle='NavBtn' NavIcon={Users} NavText="Users"/>
            <NavBtn LinkPath='/Payments' NavBtnStyle='NavBtn' NavIcon={Payments} NavText="Payments"/>
            <NavBtn LinkPath='/Blog' NavBtnStyle='NavBtn' NavIcon={Blog} NavText="Blog"/>
        </div>
     );
}
 
export default SideNav;